import * as React from 'react';
import Check from 'wix-ui-icons-common/Check';
import { InjectedTranslateProps, translate } from 'react-i18next';
import { useCallback } from 'react';
import * as s from './ViewRolePermissions.scss';
import ExternalLinkSmall from 'wix-ui-icons-common/ExternalLinkSmall';

import { MessageBoxFunctionalLayout, Card, Box, Text, TextButton, Button } from 'wix-style-react';

interface IProps extends InjectedTranslateProps {
  roleTitle: string;
  permissions: any;

  onDuplicateAndEditAction?(): void;
  onEditAction?(): void;
  closeModal(): void;
}

const ViewRolePermissions: React.FC<IProps> = ({ t, roleTitle, permissions, onDuplicateAndEditAction, onEditAction, closeModal }) => {

  const onDuplicateAndEditClick = useCallback(() => {
    closeModal();
    onDuplicateAndEditAction();
  }, [onDuplicateAndEditAction, closeModal]);

  const onEditClick = useCallback(() => {
    closeModal();
    onEditAction();
  }, [onEditAction, closeModal]);

  return (
     <MessageBoxFunctionalLayout
       noBodyPadding
       hideFooter
       title={`${roleTitle} ${t('modal.viewRolePermissions.permissions')} (${permissions.map(permission => permission.scopes).flat().length})`}
       width="890px"
       maxHeight="540px"
       onClose={closeModal}
     >
      <Box direction="vertical" maxHeight="480px">
        <Box overflow="auto" direction="vertical">{ permissions.map(permission => (
          <Card>
            <Card.Subheader title={`${permission.title} (${permission.scopes.length})`}/>
            <Box direction="vertical" verticalAlign="middle" paddingLeft="30px" paddingTop="6px" paddingBottom="18px">
              { permission.scopes.map(scope => (
                <Box height="54px" paddingTop="6px" paddingBottom="6px">
                  <Check/>
                  <Box direction="vertical" paddingLeft="12px">
                    <Text weight="normal" size="medium" dataHook="title">{ scope.title }</Text>
                    <Text size="small" weight="thin" secondary>{ scope.description }</Text>
                  </Box>
                </Box>
              ))}
            </Box>
          </Card>
        ))}
        </Box>
        <Box height="90px" paddingLeft="30px" paddingRight="30px" flexShrink={0} boxShadow="inset 0 1px 0 0 #cbd3">
          <Box width="100%" verticalAlign="middle" align="space-between">
            { onDuplicateAndEditAction && <Box>
              <Text weight="thin" className={s.duplicateAndEditText} secondary>{`${t('modal.viewRolePermissions.duplicateAndEditTitle')} `}</Text>
              <TextButton onClick={onDuplicateAndEditClick}>{` ${t('modal.viewRolePermissions.duplicateAndEdit')}`}</TextButton>
            </Box> }
            <Box>
              { onEditAction && <Button onClick={onEditClick} size="small" priority="secondary" className={s.editRoleButton}  suffixIcon={<ExternalLinkSmall/>}>{t('modal.viewRolePermissions.editRole')}</Button> }
              <Button onClick={closeModal} size="small">{t('modal.viewRolePermissions.close')}</Button>
            </Box>
          </Box>
        </Box>

      </Box>

    </MessageBoxFunctionalLayout>
  );
};

export default translate()(ViewRolePermissions);
